<app-dashboard-card
	      title="Team - MTD"
        icon="pi pi-users"
>
    <div *ngIf="loading" class="dashboard-state">
        Loading team activity...
    </div>

    <div
            *ngIf="!loading && error"
            class="dashboard-state dashboard-state-error"
    >
        Unable to load team activity.
    </div>

    <div
            *ngIf="!loading && !error && team.length === 0"
            class="dashboard-state"
    >
        No team activity was recorded for this month.
    </div>

    <div
            *ngIf="!loading && !error && team.length > 0"
            class="team-table-wrapper"
    >
        <table class="team-table">
            <thead>
            <tr>
                <th>Team Member / Group</th>
                <th>Currently with</th>
                <th>Completed</th>
                <th>Completion %</th>
            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let member of visibleTeam">
                <td>
                    <div class="team-member-name">
                        {{ member.displayName }}
                    </div>

                    <div
                            *ngIf="member.email"
                            class="team-member-email"
                    >
                        {{ member.email }}
                    </div>
                </td>

                <td class="team-claimed">
                    {{ member.currentlyWithCount }}
                </td>

                <td class="team-completed">
                    {{ member.completedCount }}
                </td>

                <td class="team-completion">
                    {{
                        member.completionPercentage === null
                            ? '—'
                            : member.completionPercentage + '%'
                    }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <div
            *ngIf="!loading && !error && hasMoreTeamMembers"
            class="dashboard-expand"
    >
        <button
                type="button"
                class="dashboard-expand-link"
                (click)="toggleExpanded()"
        >
            {{ expanded ? 'Show less' : 'Show all' }}

            <i
                    class="pi"
                    [ngClass]="
					expanded
						? 'pi-chevron-up'
						: 'pi-chevron-down'
				"
            ></i>
        </button>
    </div>
</app-dashboard-card>
